document.addEventListener('DOMContentLoaded', function () {
    // Get unavailable dates from the metafield
    const unavailableDates = window.theme?.unavailableDates || [];

    // Convert unavailable dates to a Date object array
    const unavailableDatesArray = unavailableDates.map(dateString => {
        const parts = dateString.split('-');
        return new Date(parts[0], parts[1] - 1, parts[2]);
    });

    // Function to check if a date is unavailable
    function isUnavailable(date) {
        return unavailableDatesArray.some(unavailableDate => {
            return (
                date.getFullYear() === unavailableDate.getFullYear() &&
                date.getMonth() === unavailableDate.getMonth() &&
                date.getDate() === unavailableDate.getDate()
            );
        });
    }

    // Pikaday initialization
    const datePicker = new Pikaday({
        field: document.querySelector('.datepicker'), // Change the selector to your date input field
        format: 'YYYY-MM-DD',
        toString(date, format) {
            // Format the date string using the default format
            return date.toISOString().split('T')[0];
        },
        parse(dateString, format) {
            const parts = dateString.split('-');
            return new Date(parts[0], parts[1] - 1, parts[2]);
        },
        firstDay: 0, // Set Sunday as the first day of the week
        disableDayFn(date) {
            // Disable weekends and unavailable dates
            return isWeekend(date) || isUnavailable(date);
        },
        minDate: new Date(), // Disable past dates
        showDaysInNextAndPreviousMonths: true,
        enableSelectionDaysInNextAndPreviousMonths: false,
        i18n: {
            previousMonth: 'Previous Month',
            nextMonth: 'Next Month',
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        },
        onSelect(date) {
            console.log('Selected date: ', date.toISOString().split('T')[0]);
        }
    });
});